import React from 'react';
import PropTypes from 'prop-types';

const OwnerAndFinancing = (props) => { 
    return <div className="ownerAndFinancing">
        {props.OwnerAndFinancing.OwnerType && <div className="ownerAndFinancing__item">
            <p className='ownerAndFinancing__item__text'>
            <span className='ownerAndFinancing__item__text__header'>{props.Translations.ownertype}:</span> {props.OwnerAndFinancing.OwnerType}
            </p>
        </div>}
        {props.OwnerAndFinancing.FinancingText && <div className="ownerAndFinancing__item">
            <p className='ownerAndFinancing__item__text'>
                {props.OwnerAndFinancing.FinancingText}
            </p>
        </div>}
        {props.OwnerAndFinancing.PriceLinks && (
            <div className="ownerAndFinancing__item">
                <div className="ownerAndFinancing__item__pricelinks">
                    {props.OwnerAndFinancing.PriceLinks.map((link, index) =>
                        <a key={index} href={link.Url}>{link.Text}</a>
                    )} 
                </div>
            </div>
        )}
    </div>;
}

const {string, shape, arrayOf } = PropTypes;

OwnerAndFinancing.propTypes = {
    OwnerAndFinancing: shape({
        FinancingText: string,
        OwnerType: string,
        PriceLinks: arrayOf(shape({
            Text: string,
            Url: string
        }))
    }),
    Translations: shape({
        ownertype: string,
    })
};

export default OwnerAndFinancing;